import React         from 'react'
import { Subheader } from '@/Components'

import {
  InertiaLink,
  usePage
}                           from '@inertiajs/inertia-react'
import {
  Users,
  CheckCircle,
  ArrowRightCircle
}                           from 'react-feather'

import "react-datepicker/dist/react-datepicker.css";
import { stringToInitials } from "@/Utilities/Utilities";

export default function EmissionsOwner({ teams }) {

  const organization = usePage().props?.organization?.data || {}

  function UserRow({ user }) {
    return (
      <span className="inline w-10 text-center p-2 bg-purple font-semibold rounded-full text-white -ml-2 first-of-type:bg-primary first-of-type:z-10 relative" title={user.fullname}>
        {stringToInitials(user.firstname, 1)}
      </span>
    )
  }

  return (
    <>
      <div className="mb-4 md:mb-8">
        <div className="flex flex-col md:flex-row justify-start items-start">
          <div className="md:w-2/3">
            <h2 className="mt-8 mb-2 text-5xl font-bold">Reporting</h2>
            <p>Go to your team add, report and se status of activities</p>
          </div>
        </div>

        <Subheader>CHOOSE YOUR TEAM</Subheader>
        {teams.map((team, i) => {
          return (
            <div className="flex flex-col p-8 mb-2 bg-white border border-gray-200" key={i}>
                <div className="flex flex-wrap mb-4 items-center flex-grow gap-4">
                    <span className="text-xl font-bold w-full md:w-auto">{ team.name }</span>
                    <div className="flex items-center flex-grow ml-2 md:ml-5">
                      {team.users.length > 0 && team.users.slice(0,3).map(u => <UserRow key={`user_${u.id}`} user={u}/>)}
                      {team.users.length > 4 && <span className="ml-2">+ {team.users.length - 4}</span>}
                    </div>
                    <InertiaLink href={`/teams/${team.id}`} className="text-blue underline hover:no-underline">Edit team</InertiaLink>
                </div>

                <div className="flex items-center justify-between flex-grow p-4 bg-gray-50 flex-col md:flex-row">
                    <span className="text-lg font-bold">Emission accounting</span>
                    <InertiaLink href={`/emission-accounting/teams/${team.id}`} className="flex flex-col items-center justify-center text-blue hover:underline">
                        <span>Report emissions <ArrowRightCircle className="inline-block ml-2"/></span>
                    </InertiaLink>
                </div>
            </div>
          )}
        )}

      </div>
    </>
  )
}
